import { useContext } from "react"
import { SearchConfigContext } from "./SearchConfig";

export const useSearchConfig = () => {
    return useContext(SearchConfigContext);
}